import React, {Component} from 'react';
import {ContentMainStyled, ContentSizeStyled} from "../../CommonAccess/LoginScreen/styled";
import CheckBoxDefaultComponent from "../../../Components/CheckBoxDefaultComponent/CheckBoxDefaultComponent";
import TextFieldDefault from "../../../Components/TextFieldDefaultComponent/TextFieldDefault";
import SpacerComponent from "../../../Components/SpacerComponent/SpacerComponent";
import {Box, Button, MenuItem, Typography} from "@material-ui/core";
import CheckValidDateNewAwardScreen from "../NewAward/CheckValidDateNewAwardScreen";
import FidelityService from "../../../Services/FidelityService";
import FormMask from "../../../FromMask/FormMask";
import ApiImageUtil from "../../../Utils/ApiImageUtil";
import {CashbackContext} from "../../../Contexts/CashbackContext";
import MessageUtil from "../../../Utils/MessageUtil";
import PointCalculatorComponent from "../../../Components/PointCalculatorComponent/PointCalculatorComponent";
import {ButtonDelete} from "./styled";

class FormCashbackScreen extends Component {
    static contextType = CashbackContext;

    constructor(props) {
        super(props);

        this.state = {
            type: 2,
            value_type: null,
            fidelity: [],
        };

        this.fidelityService = new FidelityService();
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.formEdit === prevProps.formEdit) {
            return;
        }
        this.setFormEdit();
    }

    setFormEdit() {
        const newState = Object.assign(this.state, this.props.formEdit);
        newState.imagePrevios = ApiImageUtil.tryGet(this.props.formEdit.images);
        newState.start_validity = (
            this.props.formEdit.start_validity === null ? undefined : this.props.formEdit.start_validity
        );
        newState.end_validity = (
            this.props.formEdit.end_validity === null ? undefined : this.props.formEdit.end_validity
        );
        if (this.props.formEdit.start_validity === null) {
            newState.withoutValidDate = true;
        }
        this.setState(newState);
    }

    async load() {
        try {

            const response = await this.fidelityService.getByUser();

            this.setState({
                fidelity: response.data.data
            });

        } catch (e) {
            throw e;
        }
    }

    setValueType = (value) => {
        this.setState({
            value_type: value,
            value: '',
        });
    }

    handleChange(event) {
        const {name, value} = event.target;
        this.setState({[name]: value});
        if (name === 'value') {
            this.rulesToValue(value);
        }
    }

    rulesToValue(value) {
        if (this.state.value_type === 2 && value > 100) {
            this.setState({
                value: 100,
            });
            this.context.parent.setState({
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: 'Desconto so pode aceitar valores entre 0% e 100%',
                }),
            });
            return;
        }
        if (this.state.value_type === 2 && value < 0) {
            this.setState({
                value: 0,
            });
            this.context.parent.setState({
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: 'Desconto so pode aceitar valores entre 0% e 100%',
                }),
            });
            return;
        }
    }

    handleValidDateChange(value) {
        this.setState({
            withoutValidDate: value,
        });
    }

    allFiedlDisabled() {
        return this.state.value_type === null;
    }

    handlerSubmit = () => {
        this.props.doCreate(this.state);
    }

    handlerDelete = () => {
        this.props.confirmDelete();
    };

    renderSelect() {

        if (this.props.isEdit === null) {
            return <div></div>;
        }

        if (this.props.isEdit === false) {
            return this.componentSelect();
        }

        if (this.props.isEdit === true && this.state.fidelity_programs_uuid === undefined) {
            return <div></div>;
        }

        return this.componentSelect();

    }

    componentSelect() {
        return (
            <TextFieldDefault select={true}
                              name={'fidelity_programs_uuid'}
                              value={this.state.fidelity_programs_uuid}
                              onChange={(event) => this.handleChange(event)}
                              erros={this.props.erros}>
                {this.makeFidelity()}
            </TextFieldDefault>
        );
    }

    makeFidelity() {
        let itens = [];
        this.state.fidelity.forEach(function (value, index) {
            itens.push(
                <MenuItem key={index} value={value.uuid}>{value.name}</MenuItem>
            );
        })

        return itens;
    }

    render() {
        return (
            <ContentMainStyled>
                <ContentSizeStyled>
                    <CheckBoxDefaultComponent onChange={() => this.setValueType(1)}
                                              label={'Valor em R$'}
                                              name={'aux1'}
                                              checked={this.state.value_type === 1}/>
                    <CheckBoxDefaultComponent onChange={() => this.setValueType(2)}
                                              label={'Valor em %'}
                                              name={'aux2'}
                                              checked={this.state.value_type === 2}/>
                    <TextFieldDefault label={'Percentual(%) - Valor *'}
                                      name={'value'}
                                      type={'number'}
                                      forceLabel={true}
                                      money={(this.state.value_type === 1)}
                                      moneyPrefix={(this.state.value_type === 1 ? 'R$ ' : '')}
                                      value={this.state.value}
                                      onChange={(event) => this.handleChange(event)}
                                      erros={this.props.erros}
                                      disabled={this.allFiedlDisabled()}/>
                    <TextFieldDefault label={'Quantidade de pontos para resgate *'}
                                      name={'value_points'}
                                      type={'number'}
                                      value={this.state.value_points}
                                      onChange={(event) => this.handleChange(event)}
                                      erros={this.props.erros}
                                      disabled={this.allFiedlDisabled()}/>
                    {this.state.value_type === 1 &&
                        <PointCalculatorComponent disabled={this.allFiedlDisabled()}
                                                  doConfirm={(result) => this.setState({value_points: result})}/>
                    }
                    <TextFieldDefault label={'Regras'}
                                      name={'rules'}
                                      value={this.state.rules}
                                      type={'number'}
                                      multiline={true}
                                      rows={5}
                                      onChange={(event) => this.handleChange(event)}
                                      erros={this.props.erros}
                                      disabled={this.allFiedlDisabled()}/>
                    <TextFieldDefault label={'Descrição *'}
                                      name={'description'}
                                      value={this.state.description}
                                      onChange={(event) => this.handleChange(event)}
                                      erros={this.props.erros}
                                      disabled={this.allFiedlDisabled()}
                                      multiline={true}
                                      rows={5}/>
                    <SpacerComponent height={20}/>
                    <Typography variant={'body1'}
                                color={'primary'}>
                        Período de Validade
                    </Typography>
                    <Box display={'flex'}
                         flexDirection={'row'}>
                        <TextFieldDefault label={'Data Inicial *'}
                                          name={'start_validity'}
                                          value={this.state.start_validity}
                                          onChange={(event) => this.handleChange(event)}
                                          type={'date'}
                                          erros={this.props.erros}
                                          forceLabel={true}
                                          disabled={this.state.withoutValidDate || this.allFiedlDisabled()}/>
                        <SpacerComponent width={40}/>
                        <TextFieldDefault label={'Data Final *'}
                                          name={'end_validity'}
                                          value={this.state.end_validity}
                                          type={'date'}
                                          onChange={(event) => this.handleChange(event)}
                                          erros={this.props.erros}
                                          forceLabel={true}
                                          disabled={this.state.withoutValidDate || this.allFiedlDisabled()}/>
                    </Box>
                    <CheckValidDateNewAwardScreen onChange={(value) => this.handleValidDateChange(value)}
                                                  withoutValidDate={this.state.withoutValidDate}/>
                    <SpacerComponent height={20}/>
                    <Typography variant={'body1'}
                                color={'primary'}>
                        Programa de Fidelidade
                    </Typography>
                    {this.renderSelect()}
                    <SpacerComponent height={20}/>
                    <Box display="flex" justifyContent="center">
                        <Button variant={'contained'}
                                color={'primary'}
                                size={"large"}
                                fullWidth={true}
                                onClick={this.handlerSubmit}>
                            {this.context.parent.state.action === 'create' ? 'Registrar Cashback' : 'Alterar Cashback'}
                        </Button>
                    </Box>
                    {this.context.parent.state.action !== 'create' &&
                        <>
                            <SpacerComponent height={20}/>
                            <Box display="flex" justifyContent="center">
                                <ButtonDelete variant={'contained'}
                                              size={"large"}
                                              fullWidth={true}
                                              onClick={this.handlerDelete}>
                                    deletar
                                </ButtonDelete>
                            </Box>
                        </>
                    }
                </ContentSizeStyled>
            </ContentMainStyled>
        );
    }
}

export default FormCashbackScreen;